"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
var _school = require("@/api/school/school");
var _index = require("@/api/education/index");
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isDisabled: false,
      eduList: [],
      formInline: {
        schoolName: "",
        schoolCode: "",
        schoolType: "",
        bureauId: ""
      },
      rules: {
        schoolName: [{
          required: true,
          message: "请输入学校名称",
          trigger: "blur"
        }, {
          min: 2,
          max: 30,
          message: "长度在 2 到 30 个字符",
          trigger: "blur"
        }],
        schoolCode: [{
          required: true,
          message: "请输入学校编码",
          trigger: "blur"
        }],
        schoolType: [{
          required: true,
          message: "请输入院校类型",
          trigger: "blur"
        }]
        // bureauId: [{ required: true, message: "请选择教育局", trigger: "blur" }]
      },
      optList: [{
        label: "中职",
        type: 1
      }, {
        label: "高职",
        type: 2
      }, {
        label: "本科",
        type: 3
      }]
    };
  },
  methods: {
    onSubmit: function onSubmit(rulesForm) {
      var _this = this;
      this.$refs[rulesForm].validate(function (valid) {
        if (valid) {
          (0, _school.schoolEdit)({
            bureauId: _this.formInline.bureauId,
            id: _this.$route.query.id,
            isLock: "",
            mechanismId: "",
            name: _this.formInline.schoolName,
            type: _this.formInline.schoolType,
            uniqueCode: _this.formInline.schoolCode
          }).then(function (res) {
            _this.$message.success("操作成功");
            _this.$router.push("/schoolTest/school");
          }).catch(function (e) {
            console.log(e);
          });
        } else {
          _this.$message.error("保存失败,请检查填写信息。");
          return false;
        }
      });
    },
    isBack: function isBack() {
      history.go(-1);
    },
    // 获取教育局列表
    getEducationList: function getEducationList() {
      var _this2 = this;
      (0, _index.getAllEducationList)().then(function (res) {
        var data = res.data;
        _this2.eduList = data;
      }).catch(function (e) {
        return e;
      });
    },
    // 根据id获取学校信息
    getInfoById: function getInfoById() {
      var _this3 = this;
      (0, _school.getScoolInfoById)({
        id: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        _this3.formInline.bureauId = data.bureauId;
        _this3.formInline.schoolName = data.name, _this3.formInline.schoolCode = data.uniqueCode, _this3.formInline.schoolType = data.type;
      });
    }
  },
  created: function created() {
    var userInfo = this.$store.state.user.userInfo;
    if (userInfo.roleType == 2) {
      this.formInline.schoolType = "1";
      this.isDisabled = true;
      this.formInline.bureauId = this.$route.query.id;
    }
    this.getEducationList();
    this.getInfoById();
    if (this.roleId == 2) {
      this.formInline.bureauId = this.cityId;
    }
  },
  computed: _objectSpread({}, (0, _vuex.mapState)({
    cityId: function cityId(state) {
      return state.user.cityId;
    },
    roleId: function roleId(state) {
      return state.user.roleId;
    }
  }))
};